import React from 'react';
import { useWidgetBuilder } from '../context/WidgetBuilderContext';
import { useBuilderLabels } from '../context/BuilderLocaleContext';
import WidgetPreview from '../widgets/WidgetPreview';

export default function PreviewPanel({ className = '' }) {
  const { config } = useWidgetBuilder();
  const t = useBuilderLabels();

  return (
    <section className={`flex flex-col min-h-0 bg-slate-100 ${className}`}>
      <div className="shrink-0 px-4 py-3 border-b border-slate-200 bg-white">
        <h2 className="text-lg font-bold text-slate-900">{t('preview')}</h2>
      </div>
      <div className="flex-1 overflow-auto p-4 min-w-0">
        <div className="w-full min-w-0 rounded-xl overflow-hidden shadow-lg border border-slate-200">
          <WidgetPreview config={config} showBranding={false} />
        </div>
      </div>
    </section>
  );
}
